import '../common/Common';
import React from 'react';
import { render } from 'react-dom';
import Controller from '../common/Controller';
import GameDay from './components/GameDay';
import 'react-virtualized/styles.css';
import { createStore, applyMiddleware } from 'redux';
import { createLogger } from 'redux-logger';
import reducers from './reducers';
import thunk from 'redux-thunk';
import { Provider } from 'react-redux';

if (ga) {
  ga('create', 'UA-22713573-6', 'auto');
}

// set up store
const store = ((state) => createStore(reducers, state, applyMiddleware(thunk, createLogger())))();

// render the application into #app
render(
  <Controller>
    <Provider store={store}>
      <GameDay/>
    </Provider>
  </Controller>,
  document.getElementById('app')
);


// WEBPACK FOOTER //
// ./src/js/GameDay/index.jsx